import {
  GET_TODO_FAIL,
  GET_TODO_SUCCESS,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
  GET_SCORES_SUCCESS,
  GET_SCORES_FAIL,
  GET_MASTER_RESOURCES_SUCCESS,
  GET_MASTER_RESOURCES_FAIL,
  GET_MASTER_NOTIFICATION_CHANNELS_SUCCESS,
  GET_MASTER_NOTIFICATION_CHANNELS_FAIL,
  GET_AWS_REFRESH,
  GET_AWS_REFRESH_SUCCESS,
  GET_AWS_REFRESH_FAIL,
  GET_MISSING_ALERTS_SUCCESS,
  GET_MISSING_ALERTS_FAIL,
  GET_MASTER_SYSTEMS_SUCCESS,
  GET_MASTER_SYSTEMS_FAIL,
  GET_CLOUD_DETAILS_SUCCESS,
  GET_CLOUD_DETAILS_FAIL,
  GET_NOTIFICATION_CHANNELS_SUCCESS,
  GET_NOTIFICATION_CHANNELS_FAIL,
  GET_COMPLETED_ALERTS_SUCCESS,
  GET_COMPLETED_ALERTS_FAIL,
  GET_NEW_RELIC_RESOURCES_SUCCESS,
  GET_NEW_RELIC_RESOURCES_FAIL,
  GET_MONITORING_SYSTEMS_SUCCESS,
  GET_MONITORING_SYSTEMS_FAIL,
  GET_NEWRELIC_METRICS_SUCCESS,
  GET_NEWRELIC_METRICS_FAIL,
  GET_NEWRELIC_MISSING_ALERTS_SUCCESS,
  GET_NEWRELIC_MISSING_ALERTS_FAIL,
  GET_NEWRELIC_DEFAULT_THRESHOLD_SUCCESS,
  GET_NEWRELIC_DEFAULT_THRESHOLD_FAIL,
  GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS,
  GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_FAIL,
  GET_NEW_RELIC_COMPLETED_ALERTS_SUCCESS,
  GET_NEW_RELIC_COMPLETED_ALERTS_FAIL,
  GET_AWS_SCAN_SUCCESS,
  GET_AWS_SCAN_FAIL,
  GET_NEWRELIC_REFRESH,
  GET_NEWRELIC_REFRESH_SUCCESS,
  GET_NEWRELIC_REFRESH_FAIL,
  GET_AWS_SCORES,
  GET_AWS_SCORES_SUCCESS,
  GET_AWS_SCORES_FAIL,
  GET_NEWRELIC_SCORES,
  GET_NEWRELIC_SCORES_SUCCESS,
  GET_NEWRELIC_SCORES_FAIL,
  GET_NEWRELIC_SCAN,
  GET_NEWRELIC_SCAN_SUCCESS,
  GET_ALL_MISSING_ALERTS,
  GET_ALL_MISSING_ALERTS_SUCCESS,
  GET_ALL_MISSING_ALERTS_FAIL,
  GET_AWS_CHART_DATA,
  GET_AWS_CHART_DATA_SUCCESS,
  GET_AWS_CHART_DATA_FAIL,
  GET_ALCOM_SCORE,
  GET_ALCOM_SCORE_SUCCESS,
  GET_ALCOM_SCORE_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_AWS,
  GET_RECENTLY_ADDED_RESOURCES_AWS_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_AWS_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_AZURE,
  GET_RECENTLY_ADDED_RESOURCES_AZURE_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_AZURE_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_GCP,
  GET_RECENTLY_ADDED_RESOURCES_GCP_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_GCP_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_DATADOG,
  GET_RECENTLY_ADDED_RESOURCES_DATADOG_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_DATADOG_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_NEWRELIC,
  GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS,
  GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_SUCCESS,
  GET_ALCOM_SCORE_BY_SERVICE_IDS,
  GET_ALCOM_SCORE_BY_SERVICE_IDS_FAIL,
  GET_ALCOM_SCORE_BY_SERVICE_IDS_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_SPLUNK,
  GET_RECENTLY_ADDED_RESOURCES_SPLUNK_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_SPLUNK_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_DYNATRACE,
  GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS,
  GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_OCI,
  GET_RECENTLY_ADDED_RESOURCES_OCI_SUCCESS,
  GET_MASTER_LOGGING_SYSTEMS_SUCCESS,
  GET_MASTER_LOGGING_SYSTEMS_FAIL,
  GET_MASTER_LOGGING_SYSTEMS,
  GET_LOGGING_SYSTEMS_SUCCESS,
  GET_LOGGING_SYSTEMS_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_GRAFANA_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_GRAFANA,
  GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_SUCCESS, GET_RECENTLY_ADDED_RESOURCES_SIGNOZ,
} from "./actionTypes";
import { GET_NEWRELIC_ALERTS_FAIL, GET_NEWRELIC_ALERTS_SUCCESS } from "../newrelic/actionTypes";
import { error } from "toastr";
import { data } from "autoprefixer";
import { act } from "react";
import Datadog from "store/datadog/reducer";

const INIT_STATE = {
  todos: [],
  profile: [],
  scores: [],
  master_resources: [],
  alerts: [],
  master_notification_channels: [],
  aws_refresh: [],
  missing_alerts: {},
  opsgenie_teams: [],
  is_aws_refreshing: false,
  master_systems: [],
  cloud_details: [],
  notification_channels: [],
  completed_alerts: [],
  new_relic_resources: [],
  monitoring_systems: [],
  new_relic_metrics: [],
  new_relic_missing_alerts: {},
  new_relic_default_threshold: [],
  new_relic_dynamic_default_threshold: [],
  new_relic_completed_alerts: [],
  aws_scan: [],
  new_relic_scan: [],
  newrelic_refresh: [],
  is_new_relic_refreshing: false,
  aws_scores: [],
  new_relic_scores: {},
  is_aws_scores: false,
  master_logging_systems: [],
  logging_systems: [],
  all_missing_alerts: {
    'Amazon Web Services': {},
    'New Relic': {},
    'Google Cloud Platform': {},
    'Datadog': {},
    'Microsoft Azure' : {},
    'App Dynamics' : {},
    'Splunk' : {},
    'Dynatrace' : {},
    'Grafana' : {},
    'Oracle Cloud Infrastructure':{} },
  chart_data: { 'dataValues': [], 'dataLabels': [] },
  alcom_score: { 'alcom_score': 0 }
};

const Dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    
    case GET_ALCOM_SCORE_BY_SERVICE_IDS:
      return{
        ...state,
        service_ids: action.payload,
      }

    case GET_ALCOM_SCORE_BY_SERVICE_IDS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_ALCOM_SCORE_BY_SERVICE_IDS_SUCCESS:
      return{
        ...state,
        AlcomScores: action.payload
      }  

    case GET_RECENTLY_ADDED_RESOURCES_AWS:
      return{
        ...state,
        data: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_AWS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        AWSCount: action.payload.total_resource_count
      }

    case GET_RECENTLY_ADDED_RESOURCES_AWS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_OCI:
      return{
          ...state,
          error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_OCI_SUCCESS:

        return{
            ...state,
            OciResources: action.payload,
            OciCount: action.payload.total_resource_count
       }

    case GET_RECENTLY_ADDED_RESOURCES_AZURE:
      return{
        ...state,
        data: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_AZURE_SUCCESS:
        return{
          ...state,
          AzureData: action.payload,
          AzureCount: action.payload.total_resource_count
        }  

    case GET_RECENTLY_ADDED_RESOURCES_AZURE_FAIL:
      return{
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_GCP:
      return{
        ...state,
        error: action.payload
      }

    case GET_RECENTLY_ADDED_RESOURCES_GCP_SUCCESS:
      return{
        ...state,
        GCPData: action.payload,
        GCPCount: action.payload.total_resource_count
      }

    case GET_RECENTLY_ADDED_RESOURCES_GCP_FAIL:
      return{
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_DATADOG:
      return {
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_DATADOG_SUCCESS:
      return {
          ...state,
          DatadogData: action.payload,
          DatadogCount: action.payload.total_resource_count
      }  

    case GET_RECENTLY_ADDED_RESOURCES_DATADOG_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_NEWRELIC:
      return {
        ...state,
        error: action.payload
      }

    case GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_SUCCESS:
      return{
        ...state,
        NewRelicData: action.payload,
        NRCount: action.payload.total_resource_count
      }

    case GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_RECENTLY_ADDED_RESOURCES_DYNATRACE:
        return{
            ...state,
            error: action.payload,
        }
    case GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_SUCCESS:
        return{
            ...state,
            DynatraceResources: action.payload,
            DynatraceCount: action.payload.total_resource_count
        }
    case GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_FAIL:
        return{
            ...state,
            error: action.payload,
        }
    case GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS:
      return{
        ...state,
        error: action.payload,
      }
    case GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_SUCCESS:
      return{
        ...state,
        SyntheticsResources: action.payload,
        SyntheticsCount: action.payload.total_resource_count
      }
    case GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_FAIL:
      return{
        ...state,
        error: action.payload,
      }
    case GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS:
      return{
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_SUCCESS:
      return{
        ...state,
        AppDynamicsResources: action.payload,
        AppDynamicsCount: action.payload.total_resource_count
      }
    case GET_RECENTLY_ADDED_RESOURCES_GRAFANA:
      return{
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_GRAFANA_SUCCESS:
      return{
        ...state,
        GrafanaResources: action.payload,
        GrafanaCount: action.payload.total_resource_count
      }

    case GET_RECENTLY_ADDED_RESOURCES_SIGNOZ:
      return{
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_SUCCESS:
      return{
        ...state,
        SignozResources: action.payload,
        SignozCount: action.payload.total_resource_count
      }

    case GET_RECENTLY_ADDED_RESOURCES_SPLUNK_FAIL:
      return{
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_SPLUNK:
      return{
        ...state,
        error: action.payload,
      }

    case GET_RECENTLY_ADDED_RESOURCES_SPLUNK_SUCCESS:
      return{
        ...state,
        SplunkResources: action.payload,
        SplunkCount: action.payload.total_resource_count
      }

    case GET_TODO_SUCCESS:
      return {
        ...state,
        todos: action.payload,
      }

    case GET_TODO_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      }

    case GET_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SCORES_SUCCESS:
      return {
        ...state,
        scores: action.payload,
      }

    case GET_SCORES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_MASTER_RESOURCES_SUCCESS:
      return {
        ...state,
        master_resources: action.payload,
      }

    case GET_MASTER_RESOURCES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_MASTER_NOTIFICATION_CHANNELS_SUCCESS:
      return {
        ...state,
        master_notification_channels: action.payload,
      }

    case GET_MASTER_NOTIFICATION_CHANNELS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_REFRESH:
      return {
        ...state,
        is_aws_refreshing: true,
        aws_refresh: action.payload,
      }


    case GET_AWS_REFRESH_SUCCESS:
      return {
        ...state,
        is_aws_refreshing: false,
        aws_refresh: action.payload,
      }

    case GET_AWS_REFRESH_FAIL:
      return {
        ...state,
        is_aws_refreshing: false,
        error: action.payload,
      }

    case GET_MISSING_ALERTS_SUCCESS:
      return {
        ...state,
        missing_alerts: Object.assign(state.missing_alerts, action.payload)
      }

    case GET_MISSING_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_MASTER_SYSTEMS_SUCCESS:
      return {
        ...state,
        master_systems: action.payload,
      }

    case GET_MASTER_SYSTEMS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CLOUD_DETAILS_SUCCESS:
      return {
        ...state,
        cloud_details: action.payload,
      }

    case GET_CLOUD_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NOTIFICATION_CHANNELS_SUCCESS:
      return {
        ...state,
        notification_channels: action.payload,
      }

    case GET_NOTIFICATION_CHANNELS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_COMPLETED_ALERTS_SUCCESS:
      return {
        ...state,
        completed_alerts: action.payload,
      }

    case GET_COMPLETED_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEW_RELIC_RESOURCES_SUCCESS:
      return {
        ...state,
        new_relic_resources: action.payload,
      }

    case GET_NEW_RELIC_RESOURCES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_MONITORING_SYSTEMS_SUCCESS:
      return {
        ...state,
        monitoring_systems: action.payload,
      }

    case GET_MONITORING_SYSTEMS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_ALERTS_SUCCESS:
      return {
        ...state,
        new_relic_alerts: action.payload,
      }

    case GET_NEWRELIC_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_METRICS_SUCCESS:
      return {
        ...state,
        new_relic_metrics: action.payload,
      }

    case GET_NEWRELIC_METRICS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_MISSING_ALERTS_SUCCESS:
      return {
        ...state,
        new_relic_missing_alerts: Object.assign(state.new_relic_missing_alerts, action.payload)
      }

    case GET_NEWRELIC_MISSING_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_DEFAULT_THRESHOLD_SUCCESS:
      return {
        ...state,
        new_relic_default_threshold: action.payload,
      }

    case GET_NEWRELIC_DEFAULT_THRESHOLD_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS:
      return {
        ...state,
        new_relic_dynamic_default_threshold: action.payload,
      }

    case GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEW_RELIC_COMPLETED_ALERTS_SUCCESS:
      return {
        ...state,
        new_relic_completed_alerts: action.payload,
      }

    case GET_NEW_RELIC_COMPLETED_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_SCAN_SUCCESS:
      return {
        ...state,
        aws_scan: action.payload,
      }

    case GET_AWS_SCAN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_SCAN:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_SCAN_SUCCESS:
      return {
        ...state,
        new_relic_scan: action.payload,
      }

    case GET_NEWRELIC_REFRESH:
      return {
        ...state,
        is_new_relic_refreshing: true,
        new_relic_refresh: action.payload,
      }

    case GET_NEWRELIC_REFRESH_SUCCESS:
      return {
        ...state,
        is_new_relic_refreshing: false,
        new_relic_refresh: action.payload,
      }

    case GET_NEWRELIC_REFRESH_FAIL:
      return {
        ...state,
        is_new_relic_refreshing: false,
        error: action.payload,
      }

    case GET_AWS_SCORES:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_SCORES_SUCCESS:
      return {
        ...state,
        aws_scores: Object.assign(state.aws_scores, action.payload),
        is_aws_scores: !state.is_aws_scores
      }

    case GET_AWS_SCORES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_SCORES:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_SCORES_SUCCESS:
      return {
        ...state,
        new_relic_scores: Object.assign(state.new_relic_scores, action.payload)
      }

    case GET_NEWRELIC_SCORES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ALL_MISSING_ALERTS:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ALL_MISSING_ALERTS_SUCCESS:
      return {
        ...state,
        all_missing_alerts: Object.assign(state.all_missing_alerts, action.payload)
      }

    case GET_ALL_MISSING_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ALCOM_SCORE:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ALCOM_SCORE_SUCCESS:
      return {
        ...state,
        alcom_score: Object.assign(state.alcom_score, action.payload)
      }

    case GET_ALCOM_SCORE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_CHART_DATA:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_CHART_DATA_SUCCESS:
      return {
        ...state,
        chart_data: Object.assign(state.chart_data, action.payload)
      }

    case GET_AWS_CHART_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      }

      case GET_MASTER_LOGGING_SYSTEMS_SUCCESS:
        return {
          ...state,
          master_logging_systems: action.payload,
        }

      case GET_MASTER_LOGGING_SYSTEMS_FAIL:
        return {
          ...state,
          error: action.payload,
        }

      case GET_LOGGING_SYSTEMS_SUCCESS:
        return {
          ...state,
          logging_systems: action.payload,
        }

      case GET_LOGGING_SYSTEMS_FAIL:
        return {
          ...state,
          error: action.payload,
        }

    default:
      return state
  }
}


export default Dashboard;